export const author = [
    {
        id: 1,
        "firstName": "Timothy",
        "description": null,
        "name": "Timothy Sykes",
        "lastName": "Sykes",
        "avatar": {
            "url": "https://secure.gravatar.com/avatar/092522e87ab76a4bb688d6bfdc0b4f2e?s=96&d=mm&r=g",
            "size": 96
        }
    },
    {
        id: 6500,
        "firstName": "Tim-",
        "description": null,
        "name": "Tim bot",
        "lastName": "bot",
        "avatar":
        {
            "url": "https://secure.gravatar.com/avatar/341a364cbdd97f47f09948e5ca2e682e?s=96&d=mm&r=g",
            "size": 96
        }
    },
    {
        id: 6486,
        "firstName": "Matt",
        "description": null,
        "name": "Matt Monaco",
        "lastName": "Monaco",
        "avatar": {
            "url": "https://secure.gravatar.com/avatar/f47e982e112566f6e63ad14aa64d1829?s=96&d=mm&r=g",
            "size": 96
        }
    }
]


export const findAuthor = (id) => {
    return author.find(item => item.id === id);
}